import { render } from "./ContactUsPage.vue?vue&type=template&id=6d4f94a7&ts=true"
import script from "./ContactUsPage.vue?vue&type=script&lang=ts"
export * from "./ContactUsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__